module.exports = __webpack_public_path__ + "static/img/site-3.82ba604.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/site-3.png
// module id = MwX3
// module chunks = 0